/**
 * @file Route: newsletter
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

 import "layouts/main";
 import { $all } from "@olmokit/dom";
import { globalData } from "@olmokit/core/data";
import projects from "components/VisualProjects";
import "components/Cover";
import "components/Related";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormNewsletter } from "components/Form";
import "./index.scss";

console.log("Route newsletter/index.js mounted.");

replaceFragment("contactForm", "components.FormNewsletter").then(() => FormNewsletter());
// FormNewsletter();


const glideEl = $all(".glide");
if (glideEl.length > 0) {
    if (globalData.sliderprojects) {
        projects('.VisualProjects:'+globalData.sliderprojects);
    }
}
